import {Component, Inject, OnInit} from '@angular/core';
import {
  financialModelErrorToTooltip,
  GetProjectsFinancialModel
} from '../../../services/project-details/GetProjectsFinancialModel';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ProjectDetailsService} from '../../../services/project-details/project-details.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'digires-financial-model-upload-dialog',
  templateUrl: './financial-model-upload-dialog.component.html',
  styleUrls: ['./financial-model-upload-dialog.component.scss']
})
export class FinancialModelUploadDialogComponent implements OnInit {

  readonly financialModelErrorToTooltip = financialModelErrorToTooltip;

  formGroup: FormGroup;
  financialModel: GetProjectsFinancialModel;
  hasFailed: boolean;
  isProjectCreation: boolean;

  constructor(
    private detailsService: ProjectDetailsService,
    @Inject(MAT_DIALOG_DATA) public data: {
      projectId: string,
      file: File,
    }
  ) {
    this.isProjectCreation = !this.data.projectId;
  }

  ngOnInit(): void {
    if (this.isProjectCreation) {
      this.formGroup = new FormGroup({});
    } else {
      this.formGroup = new FormGroup({
        reason: new FormControl('', [Validators.required, Validators.minLength(1)]),
      });
    }
    // short wait before initiating upload
    setTimeout(() => {
      this.checkFinancialModel();
    }, 1000);
  }

  private checkFinancialModel() {
    const promise: Promise<GetProjectsFinancialModel> =
      this.isProjectCreation
        ? this.detailsService.checkFinancialModelForProjectCreation(this.data.file)
        : this.detailsService.checkFinancialModelForExistingProject(this.data.projectId, this.data.file)
      ;
    promise
      .then(financialModel => {
        this.financialModel = financialModel;
      })
      .catch(error => {
        console.error('error=', error);
        this.hasFailed = true;
      });
  }

  createConfirmResponse() {
    return {
      financialModel: this.financialModel,
      keyDataChangeReason: this.formGroup.value.reason,
    };
  }

}
